var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradiantBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 979,
    height: 1027,
    viewBox: "0 0 979 1027",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter0_f_7348_12501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.592 365.574C667.222 399.748 750.225 380.596 773.375 430.95C795.032 478.055 737.929 525.571 719.415 573.998C702.978 616.995 694.567 661.427 670.308 700.547C641.072 747.693 617.904 812.14 563.892 824.794C509.539 837.527 466.89 771.832 412.119 761.036C351.574 749.102 276.078 800.232 230.156 759.011C185.095 718.563 202.602 641.201 211.97 581.378C219.413 533.846 273.179 503.532 277.662 455.631C283.604 392.154 214.013 328.999 240.998 271.238C265.526 218.737 338.841 204.018 396.701 200.831C451.004 197.839 503.882 222.379 547.89 254.332C584.813 281.142 587.67 337.437 623.592 365.574Z",
    fill: "url(#paint0_linear_7348_12501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7348_12501",
    x: 0.651184,
    y: 0.583984,
    width: 977.555,
    height: 1025.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_7348_12501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7348_12501",
    x1: 467.544,
    y1: 216.531,
    x2: 298.92,
    y2: 1445.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#107281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CA485"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradiantBg);
export default __webpack_public_path__ + "static/media/gradiantBg.c8e10c8d783a495fd5df47860c3a2fa0.svg";
export { ForwardRef as ReactComponent };